import { Map } from 'immutable';
import * as fetchingState from '../constants/fetchingState';
import * as settingTypes from '../constants/settingTypes';
import * as reportConstants from '../constants/analytics';
import authReducer from './authReducer';

import callbackReducer from './callbackReducer';
import { customerReducer, customerExistsReducer } from './customerReducer';
import orderReducer from './orderReducer';
import serviceCategoryReducer from './serviceCategoryReducer';
import addressesReducer from './addressesReducer';
import settingsReducer from './settingsReducer';
import deliveryReducer from './deliveryReducer';
import agentsReducer from './agentsReducer';
import reportReducer from './reportReducer';

const initialState = Map({
    callbacks: {
        fetching: fetchingState.INITIAL,
        enquiries: [],
        updateFetching: fetchingState.INITIAL,
        updateResult: undefined,
        historyFetching: fetchingState.INITIAL,
        history: []
    },
    auth: new Map({
        fetching: fetchingState.INITIAL,
        error: undefined,
        user: undefined
    }),
    orders: new Map({
        fetching: fetchingState.INITIAL,
        debugInfoFetching: fetchingState.INITIAL,
        fullOrderInfo: null,
        orders: [],
        pages: 0,
        updateFetching: fetchingState.INITIAL,
        createFetching: fetchingState.INITIAL,
        updateResult: undefined,
        pendingOrdersCount: 0,
        updateError: undefined,
        workTime: {
            pickup: null,
            offload: null,
            pickupFetching: fetchingState.INITIAL,
            offloadFetching: fetchingState.INITIAL
        }
    }),
    serviceCategory: new Map({
        service: {
            fetching: fetchingState.INITIAL,
            services: [],
            updateFetching: fetchingState.INITIAL,
            updateResult: undefined,
            createFetching: fetchingState.INITIAL,
            createResult: undefined
        },
        category: {
            fetching: fetchingState.INITIAL,
            categories: [],
            updateFetching: fetchingState.INITIAL,
            updateResult: undefined,
            createFetching: fetchingState.INITIAL,
            createResult: undefined
        }
    }),
    customer: {
        fetching: fetchingState.INITIAL,
        customers: [],
        updateFetching: fetchingState.INITIAL,
        updateResult: undefined,
        createFetching: fetchingState.INITIAL,
        createResult: undefined,
        resetPasswordFetching: fetchingState.INITIAL,
        smsSendindErrors: undefined,
        smsSendFetching: fetchingState.INITIAL,
        pages: 0,
        perPage: 1,
        totalAmount: 0
    },
    customerExists: new Map({
        customerExist: false,
        fetching: fetchingState.INITIAL,
        customer: undefined
    }),
    delivery: {
        cancelError: null,
        cancelFetching: fetchingState.INITIAL
    },
    addresses: {
        fetching: fetchingState.INITIAL,
        addresses: []
    },
    settings: {
        [settingTypes.delivery]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.defaultWorkTime]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.schedule]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null,
        },
        [settingTypes.departments]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null,
        },
        [settingTypes.websiteMeta]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null,
        },
        [settingTypes.employees]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            createFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.agents]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null,
            active: null,
            activeFetching: fetchingState.INITIAL
        },
        [settingTypes.faqs]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.popularity]:{
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.tablesSettings]:{
            fetchingState: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.reviews]:{
            fetchingState: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.promo]:{
            fetchingState: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.news]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.counter]:{
            fetchingState: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.sms]:{
            fetchingState: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            data: null
        },
        [settingTypes.documents]: {
            fetching: fetchingState.INITIAL,
            updateFetching: fetchingState.INITIAL,
            deleteFetching: fetchingState.INITIAL,
            data: null
        },
    },
    reports: {
        [reportConstants.popularServicesReport]: {
            fetching: fetchingState.INITIAL,
            data: []
        },
        [reportConstants.orderStateReport]: {
            fetching: fetchingState.INITIAL,
            data: {}
        },
        [reportConstants.popularClicksReport]: {
            fetching: fetchingState.INITIAL,
            data: []
        }
    }
});

export default function(state, action) {
    if (!state) {
        return initialState;
    }

    state = state.update('callbacks', (c) => callbackReducer(c, action));
    state = state.update('auth', (a) => authReducer(a, action));
    state = state.update('orders', o => orderReducer(o, action));
    state = state.update('customerExists', c => customerExistsReducer(c, action));
    state = state.update('serviceCategory', sc => serviceCategoryReducer(sc, action));
    state = state.update('customer', c => customerReducer(c, action));
    state = state.update('addresses', a => addressesReducer(a, action));
    state = state.update('settings', s => settingsReducer(s, action));
    state = state.update('delivery', d => deliveryReducer(d, action));
    state = state.update('settings', s => agentsReducer(s, action));
    state = state.update('reports', r => reportReducer(r, action));
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/applicationReducer.js